<template>
    <div>
        <!-- Top Bar -->
        <div class="top-bar" :class="{ 'top-bar-hidden': isScrolled, 'top-bar-mobile': isMobile }">
            <div class="container">
                <nav class="segment-nav">
                    <a href="#" class="active" style="visibility:hidden;">{{ $t('nav.home') }}</a>
                </nav>
                <div class="top-actions">
                    <CurrencyTicker style="visibility: hidden;"/>
                    <LanguageSwitcher />
                    <router-link :to="{ name: 'login', params: { lang: currentLang } }" class="top-link">
                        <ion-icon name="person-circle-outline"></ion-icon>
                        {{ $t('nav.private_area') }}
                    </router-link>
                    <a href="https://www.asisa.es/contacto" target="_blank" rel="noopener noreferrer" class="top-link">
                        <ion-icon name="call-outline"></ion-icon> {{ $t('nav.Urgencias') }}
                    </a>
                </div>
            </div>
        </div>

        <!-- Main Header -->
        <header class="main-header" :class="{ 'header-scrolled': isScrolled, 'header-mobile': isMobile }">
            <div class="container header-container">
                <div class="logo">
                    <a href="https://www.unitseguros.com/oficina/murcia-cabezo-torres/#" target="_blank" rel="noopener noreferrer" 
                       class="logo-unit">
                        <img src="/distr_autorizado.png" alt="Unit Seguros">
                        <span class="distribuidor-text">{{ $t('nav.distribuidor') }}</span>
                    </a>
                    <span class="separator">|</span>
                    <router-link :to="{ name: 'home', params: { lang: currentLang } }" class="logo-asisa">
                        <img src="/logo.png" alt="ASISA Health Visa">
                    </router-link>
                    <span class="separator">|</span>
                    <span class="brand-claim">Expatriados / VISA</span>
                </div>

                <!-- Menú de navegación -->
                <nav class="main-nav" :class="{ 'mobile-open': mobileMenuOpen }">
                    <ul>
                        <li><router-link :to="{ name: 'salud-completa', params: { lang: currentLang } }" @click="closeMobileMenu">{{ $t('nav.health') }}</router-link></li>
                        <li><router-link :to="{ name: 'seguros-dentales', params: { lang: currentLang } }" @click="closeMobileMenu">{{ $t('nav.dental') }}</router-link></li>
                        <li><router-link :to="{ name: 'blog', params: { lang: currentLang } }" @click="closeMobileMenu">{{ $t('nav.blog') }}</router-link></li>
                    </ul>
                </nav>

                <div class="header-cta">
                    <div class="phone-block">
                        <span class="phone-label">{{ $t('nav.Llamanos') }}</span>
                        <a href="tel:968909911" class="phone-number">968 90 99 11</a>
                    </div>
                    <router-link :to="{ name: 'calculadora', params: { lang: currentLang } }" class="btn btn-primary btn-sm">
                        {{ $t('nav.ContrataOnline') }}
                    </router-link>
                </div>

                <!-- Botón de menú móvil -->
                <button class="mobile-menu-btn" @click="toggleMobileMenu" :aria-expanded="mobileMenuOpen">
                    <ion-icon :name="mobileMenuOpen ? 'close-outline' : 'menu-outline'"></ion-icon>
                </button>
            </div>
        </header>

        <!-- Espaciador (solo en desktop) -->
        <div class="header-spacer" v-if="!isMobile"></div>
    </div>
</template>

<script>
import CurrencyTicker from '@/components/common/CurrencyTicker.vue'
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'

export default {
    name: 'AppHeader',
    components: { 
        CurrencyTicker,
        LanguageSwitcher
     },
    data() {
        return {
            isScrolled: false,
            mobileMenuOpen: false,
            isMobile: window.innerWidth <= 900
        }
    },
    computed:{
        currentLang() {
            return this.$route.params.lang || 'es'
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll, { passive: true })
        window.addEventListener('resize', this.handleResize)
        document.addEventListener('click', this.handleClickOutside)
        
        this.$watch('$route', () => {
            this.closeMobileMenu()
        })
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
        window.removeEventListener('resize', this.handleResize)
        document.removeEventListener('click', this.handleClickOutside)
    },
    methods: {
        handleScroll() {
            this.isScrolled = window.scrollY > 50
        },
        handleResize() {
            this.isMobile = window.innerWidth <= 900
            if (!this.isMobile) {
                this.closeMobileMenu()
            }
        },
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen
            if (this.mobileMenuOpen) {
                document.body.style.overflow = 'hidden'
            } else {
                document.body.style.overflow = ''
            }
        },
        closeMobileMenu() {
            this.mobileMenuOpen = false
            document.body.style.overflow = ''
        },
        handleClickOutside(event) {
            const header = event.target.closest('.main-header')
            const menuBtn = event.target.closest('.mobile-menu-btn')
            if (!header && !menuBtn && this.mobileMenuOpen) {
                this.closeMobileMenu()
            }
        }
    }
}
</script>

<style scoped>
/* ========================================== */
/* ========== TOP BAR (Desktop) ========== */
/* ========================================== */
.top-bar {
    background-color: #f1f3f5;
    border-bottom: 1px solid #e9ecef;
    padding: 8px 0;
    font-size: 0.85rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1002;
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.top-bar.top-bar-hidden {
    transform: translateY(-100%);
    opacity: 0;
}

.top-bar .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.top-actions {
    display: flex;
    align-items: center;
    gap: 20px;
}

.top-link {
    color: #5f6368;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 0.85rem;
    transition: color 0.2s;
}

.top-link:hover {
    color: #1C4A8D;
}

.top-link ion-icon {
    font-size: 1.2rem;
}

/* ========================================== */
/* ========== TOP BAR (Móvil) ============== */
/* ========================================== */
.top-bar-mobile {
    position: relative !important;
    top: 0 !important;
    transform: none !important;
    opacity: 1 !important;
    z-index: 1 !important;
    padding: 4px 0 !important;  /* ✅ Reducido */
    font-size: 0.75rem !important;  /* ✅ Texto más pequeño */
}

.top-bar-mobile .top-link {
    font-size: 0.7rem !important;
}

.top-bar-mobile .top-link ion-icon {
    font-size: 1rem !important;
}

.top-bar-mobile .top-actions {
    gap: 10px !important;
}

/* ========================================== */
/* ========== MAIN HEADER (Desktop) ========= */
/* ========================================== */
.main-header {
    background-color: white;
    padding: 12px 0;
    position: fixed;
    top: 40px;
    left: 0;
    right: 0;
    z-index: 1001;
    transition: padding 0.3s ease, box-shadow 0.3s ease, top 0.3s ease;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.main-header.header-scrolled {
    top: 0;
    padding: 8px 0;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.main-header.header-scrolled .logo-unit img,
.main-header.header-scrolled .logo-asisa img {
    height: 32px;
}

.main-header.header-scrolled .distribuidor-text {
    font-size: 0.45rem;
}

.main-header.header-scrolled .brand-claim {
    font-size: 0.75rem;
}

/* ========================================== */
/* ========== MAIN HEADER (Móvil) ========== */
/* ========================================== */
.header-mobile {
    position: relative !important;
    top: 0 !important;
    padding: 6px 0 !important;  /* ✅ Reducido */
    box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

/* ✅ Logos más pequeños en móvil */
.header-mobile .logo-unit img,
.header-mobile .logo-asisa img {
    height: 28px !important;  /* ✅ Reducido */
}

.header-mobile .distribuidor-text {
    font-size: 0.4rem !important;
    margin-top: 1px !important;
}

.header-mobile .separator {
    font-size: 0.9rem !important;
}

.header-mobile .brand-claim {
    font-size: 0.7rem !important;
}

.header-mobile .header-cta .btn-primary {
    padding: 4px 10px !important;
    font-size: 0.65rem !important;
}

.header-mobile .phone-number {
    font-size: 0.75rem !important;
}

.header-mobile .phone-label {
    font-size: 0.55rem !important;
}

.header-mobile .mobile-menu-btn {
    font-size: 1.5rem !important;
    padding: 2px !important;
}

/* ✅ Logo container más compacto */
.header-mobile .logo {
    gap: 8px !important;
}

/* ========================================== */
/* ========== ESPACIADOR (solo desktop) ==== */
/* ========================================== */
.header-spacer {
    height: 82px;
}

/* ========================================== */
/* ========== RESTO DE ESTILOS ============= */
/* ========================================== */
.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.logo {
    display: flex;
    align-items: center;
    gap: 15px;
}

.logo-unit {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
}

.logo-unit img {
    height: 40px;
    width: auto;
    transition: height 0.3s ease;
}

.distribuidor-text {
    font-size: 0.55rem;
    font-weight: 700;
    color: #1C4A8D;
    letter-spacing: 1px;
    margin-top: 3px;
    white-space: nowrap;
}

.separator {
    color: #ccc;
    font-weight: 300;
    font-size: 1.5rem;
    line-height: 1;
}

.logo-asisa {
    display: flex;
    align-items: center;
    text-decoration: none;
    gap: 10px;
}

.logo-asisa img {
    height: 40px;
    width: auto;
    transition: height 0.3s ease;
}

.brand-claim {
    font-size: 0.9rem;
    font-weight: 500;
    color: #1C4A8D;
}

/* ========== NAVEGACIÓN ========== */
.main-nav ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    align-items: center;
    gap: 25px;
}

.main-nav a {
    text-decoration: none;
    font-weight: 600;
    color: #1C4A8D;
    padding: 8px 0;
    transition: color 0.3s;
    white-space: nowrap;
    position: relative;
}

.main-nav a::after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: #F04B00;
    transition: width 0.3s;
}

.main-nav a:hover::after {
    width: 100%;
}

.main-nav a:hover {
    color: #F04B00;
}

/* ========== HEADER CTA ========== */
.header-cta {
    display: flex;
    align-items: center;
    gap: 20px;
}

.phone-block {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    line-height: 1.2;
}

.phone-label {
    font-size: 0.7rem;
    color: #5f6368;
}

.phone-number {
    font-weight: 700;
    font-size: 1rem;
    color: #1C4A8D;
    text-decoration: none;
}

.btn-primary {
    background-color: #1C4A8D;
    color: white;
    padding: 8px 20px;
    border-radius: 0;
    text-decoration: none;
    font-weight: 600;
    font-size: 0.85rem;
    transition: background-color 0.3s;
}

.btn-primary:hover {
    background-color: #143A6E;
}

/* ========== MENÚ MÓVIL ========== */
.mobile-menu-btn {
    display: none;
    background: none;
    border: none;
    font-size: 1.8rem;
    cursor: pointer;
    color: #1C4A8D;
    padding: 5px;
    line-height: 1;
    z-index: 1002;
}

.mobile-menu-btn:hover {
    color: #F04B00;
}

/* ========================================== */
/* ========== RESPONSIVE =================== */
/* ========================================== */

/* Tablets y escritorio pequeño */
@media (max-width: 1024px) {
    .main-nav ul {
        gap: 15px;
    }
    .main-nav a {
        font-size: 0.85rem;
    }
    .brand-claim {
        display: none;
    }
}

/* Móvil y tablets */
@media (max-width: 900px) {
    /* ✅ TOP BAR - NO FIJA en móvil */
    .top-bar {
        position: relative !important;
        top: 0 !important;
        transform: none !important;
        opacity: 1 !important;
        z-index: 1 !important;
        padding: 4px 0 !important;
    }

    /* ✅ MAIN HEADER - NO FIJO en móvil */
    .main-header {
        position: relative !important;
        top: 0 !important;
        padding: 6px 0 !important;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
    }

    /* ✅ Espaciador oculto */
    .header-spacer {
        display: none !important;
    }

    /* ✅ Menú móvil */
    .main-nav {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1001;
        animation: fadeIn 0.3s ease;
    }

    .main-nav.mobile-open {
        display: block;
    }

    .main-nav ul {
        position: fixed;
        top: 0;
        right: 0;
        width: 75%;
        max-width: 320px;
        height: 100vh;
        background: white;
        flex-direction: column;
        padding: 70px 30px 30px 30px;
        gap: 20px;
        box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
        animation: slideIn 0.3s ease;
        overflow-y: auto;
        margin: 0;
        align-items: flex-start;
    }

    .main-nav ul li {
        width: 100%;
    }

    .main-nav ul li a {
        display: block;
        padding: 12px 0;
        font-size: 1.1rem;
        border-bottom: 1px solid #f0f0f0;
        color: #1C4A8D;
        text-decoration: none;
        font-weight: 600;
    }

    .main-nav ul li a::after {
        display: none;
    }

    .main-nav ul li a:hover {
        color: #F04B00;
    }

    .mobile-menu-btn {
        display: block;
    }
}

/* Animaciones */
@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

/* ========================================== */
/* ========== MÓVIL PEQUEÑO ================ */
/* ========================================== */

@media (max-width: 768px) {
    .top-bar {
        padding: 3px 0 !important;
    }
    .top-bar .top-link {
        font-size: 0.65rem !important;
    }
    .top-bar .top-link ion-icon {
        font-size: 0.9rem !important;
    }
    .top-bar .top-actions {
        gap: 8px !important;
        margin-left: -100% !important;
    }
    
    .main-header {
        padding: 4px 0 !important;
    }
    
    .main-header .logo-unit img,
    .main-header .logo-asisa img {
        height: 24px !important;
    }
    
    .main-header .separator {
        font-size: 0.8rem !important;
    }
    
    .main-header .brand-claim {
        font-size: 0.6rem !important;
    }
    
    .main-header .distribuidor-text {
        font-size: 0.35rem !important;
        margin-top: 0 !important;
    }
    
    .main-header .header-cta .btn-primary {
        padding: 3px 8px !important;
        font-size: 0.55rem !important;
    }
    
    .main-header .phone-number {
        font-size: 0.65rem !important;
    }
    
    .main-header .phone-label {
        display: none !important;
    }
    
    .main-header .mobile-menu-btn {
        font-size: 1.3rem !important;
        padding: 2px !important;
    }
    
    .main-header .logo {
        gap: 5px !important;
    }
}

@media (max-width: 576px) {
    .top-bar .top-link {
        font-size: 0.55rem !important;
    }
    .top-bar .top-link ion-icon {
        font-size: 0.8rem !important;
    }
    .top-bar .top-actions {
        gap: 5px !important;
        margin-left: -100% !important;
    }
    
    .main-header .logo-unit img,
    .main-header .logo-asisa img {
        height: 20px !important;
    }
    
    .main-header .brand-claim {
        display: none !important;
    }
    
    .main-header .separator {
        font-size: 0.7rem !important;
    }
    
    .main-header .header-cta .btn-primary {
        padding: 2px 6px !important;
        font-size: 0.5rem !important;
    }
    
    .main-header .phone-number {
        display: none !important;
    }
    
    .main-header .mobile-menu-btn {
        font-size: 1.2rem !important;
    }
    
    .main-nav ul {
        padding: 60px 20px 20px 20px !important;
    }
}
</style>